import React from 'react';
import type NewIssueSearchTransitionApp from '@atlassian/jira-spa-apps-admin-pages-new-issue-search-transition/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyNewIssueSearchTransition = lazyForPaint<typeof NewIssueSearchTransitionApp>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-new-issue-search-transition", jiraSpaEntry: "async-admin-pages-new-issue-search-transition" */ '@atlassian/jira-spa-apps-admin-pages-new-issue-search-transition'
		),
	),
);

const AsyncNewIssueSearchTransition = (): React.JSX.Element => (
	<LazyPage
		Page={LazyNewIssueSearchTransition}
		pageId="jira-admin-pages-new-issue-search-transition"
		shouldShowSpinner
	/>
);

export default AsyncNewIssueSearchTransition;
